export function BluePaper() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="26"
      fill="none"
      viewBox="0 0 20 26"
    >
      <g stroke="#363BC4" strokeLinejoin="round" strokeWidth="2">
        <path d="M1 22.857V2.286A1.286 1.286 0 012.286 1h7.935c.682 0 1.336.271 1.818.753l6.208 6.208c.482.482.753 1.136.753 1.818v13.078a1.286 1.286 0 01-1.285 1.286H2.285A1.286 1.286 0 011 22.857z" />
        <path d="M10 1v7.714A1.286 1.286 0 0011.286 10H19" />
      </g>
    </svg>
  );
}

export default BluePaper;
